import { useEffect, useState } from 'react'
import BidButton from '../../../../elements/BidButton/BidButton'
import { MdKeyboardBackspace } from 'react-icons/md'

const BackToFilteredAuctions = () => {
  const [lastPath, setLastPath] = useState('/category/all/1')

  useEffect(() => {
    const newLastPath = window.localStorage.getItem(
      'lastKnownFilteredAuctionPage'
    )
    if (newLastPath) {
      setLastPath(newLastPath)
    }
  }, [])

  return (
    <BidButton
      label={
        <span className="flex justify-center items-center gap-1">
          <MdKeyboardBackspace />
          Back To Filtered Auctions
        </span>
      }
      theme="blue-light"
      width="full"
      type="link"
      link={lastPath}
      className={'px-1 py-1'}
    />
  )
}

export default BackToFilteredAuctions
